import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const cmpCreatedVsResolvedRoute: InvariantJiraRoute = {
	name: 'software-reports-created-vs-resolved-cmp',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/reports/created-vs-resolved',
};
